<ndt-register-view
   [name]="pluralName"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [showCreate]="true"
   [hideHeader]="hideHeader"
   [pluralNameOverride]="pluralName"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <ndt-register-quick-filter>
      <mat-form-field class="flex-half">
         <mat-label>Provider</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            id="providerId"
            lcsStaticSelect
            [ngModel]="selectedProvider"
            (search)="providerSearch($event)"
            (reset)="providerReset()"
            (ngModelChange)="onProviderTypeSelected($event)"
            [lcsSingleSelect]="providerSelect"
            [lcsStaticSelectValue]="selectedProvider"
            readonly
         />
         <lcs-static-select #providerSelect [displayWith]="providerDisplayWith" isIncludeEmptyOption="true">
            <lcs-option [value]="null" disabled></lcs-option>
            @for (provider of providers; track provider) {
            <lcs-option [value]="provider"> {{ provider }} </lcs-option>
            }
         </lcs-static-select>
      </mat-form-field>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>

         <ng-container lcsColumnDef="provider" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="active-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="providerTypeName"
               >Provider <mat-icon class="mat-icon-sort">{{ getSort('providerTypeName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callRate">
               {{ callRate.providerId }}
            </td>
         </ng-container>

         <ng-container lcsColumnDef="code" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="active-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="code"
               >Code <mat-icon class="mat-icon-sort">{{ getSort('code') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callRate">
               {{ callRate.code }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="destination" width="5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="active-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="destination"
               >Destination <mat-icon class="mat-icon-sort">{{ getSort('destination') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callRate">
               {{ callRate.destination }}
            </td>
         </ng-container>
         <ng-container
            lcsColumnDef="cost"
            width="2"
            ndtSortColumn
            (emitter)="onOrderingOptionsChange($event)"
            sortDirection="NotSet"
            sortField="destination"
         >
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="active-column-header"
               class="register-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="rate"
               >Cost <mat-icon class="mat-icon-sort">{{ getSort('rate') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callRate">
               {{ callRate.rate }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="updateDate" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="active-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="updateDate"
               >Update Date <mat-icon class="mat-icon-sort">{{ getSort('updateDate') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callRate">
               {{ callRate.updateDate | date : 'MM/dd/yyyy hh:mm:ss aa' }}
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
